__turbopack_context__.v({
  "kabob_menu_arrow": "KabobMenu-module-scss-module__4qPNsG__kabob_menu_arrow",
  "kabob_menu_button": "KabobMenu-module-scss-module__4qPNsG__kabob_menu_button",
  "kabob_menu_close_button": "KabobMenu-module-scss-module__4qPNsG__kabob_menu_close_button",
  "kabob_menu_content": "KabobMenu-module-scss-module__4qPNsG__kabob_menu_content",
  "kabob_menu_content_inner": "KabobMenu-module-scss-module__4qPNsG__kabob_menu_content_inner",
});
